import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  Source,
  SourceValues,
  TransportationMode,
  TransportationModeValues,
  ValuesMobilityPublic,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionMobilityPublicDto } from './dto.type';

export class QuestionMobilityPublicMapper {
  static dtoToEntity(
    dto: QuestionMobilityPublicDto,
  ): ImpactCo2Answer<ValuesMobilityPublic> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'MOBILITY_PUBLIC',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        transportationMode: validateValueInType<TransportationMode>(
          dto.transportationMode,
          TransportationModeValues,
        ),
        passengerCount: Number.parseFloat(dto.passengerCount.toString()),
        travelDistance: Number.parseFloat(dto.travelDistance.toString()),
        departurePoint: dto.departurePoint,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesMobilityPublic>,
    projectId: number,
  ): Omit<QuestionMobilityPublicDto, 'id' | 'userId' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      transportationMode: answer.values.transportationMode,
      passengerCount: answer.values.passengerCount,
      travelDistance: answer.values.travelDistance,
      departurePoint: answer.values.departurePoint,
      label: '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
